// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 85) return "static/chunks/38367f19-0038ffc211e26277.js";
	if (chunkId === 400) return "static/chunks/400-7468d7350eee812c.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"cfb1a57ca001a849","244":"2a836c88fa46d088","319":"0cbc2894a3f1b950","340":"ef6b40bf80906c48","367":"2ceaa5a630c58634","639":"e7b660adfa99260e","748":"13b3a6bca4ae103c"}[chunkId] + ".js";
};